import { withMotionMax } from '@hoc/withMotionMax';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import CarouselProvider from '../Misc/Carousels/Carousel/CarouselProvider/CarouselProvider';
import Pagination from '../Misc/Carousels/Carousel/Pagination/Pagination';
import S from './CardGrid.styles';
const CardGrid = ({ children, mobileCarousel, rowMax, paddingOffset, translations, carouselType, ...props }) => {
    return (React.createElement(S.Container, { "data-carousel": mobileCarousel, "data-row-max": rowMax, ...props }, renderLayout()));
    function renderLayout() {
        if (mobileCarousel) {
            const count = React.Children.count(children);
            return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
                React.createElement(CarouselProvider, { count: count, paddingOffset: paddingOffset ?? 0 },
                    React.createElement(S.Track, null, React.Children.map(children, (child) => (React.createElement(S.Item, null, child)))),
                    React.createElement(Pagination, { translations: translations, variant: carouselType }))));
        }
        return children;
    }
};
export default withMotionMax(CardGrid);
